import React from 'react';
import { Icon } from './Icon.js';
export const IconHouseGrin = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 21V8.75L12 2L3 8.75V21H21Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M9 11L9 11.01", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M15 11L15 11.01", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12 18C14.2091 18 16 16.2091 16 14H8C8 16.2091 9.79086 18 12 18Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconHouseGrin.js.map